module.exports = __webpack_public_path__ + "img/3.06.thmb.xs.95f68e2c.jpg";